import * as React from 'react'

import { Box, Button, InputCheckBox, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

type ModalProps = React.ComponentProps<typeof Modal>

interface Props {
  candidateFullName: string
  onClose: () => void
  onSubmit: ModalProps['onSubmit']
  onClick: () => void
  checked: boolean
}

export const ConfirmationModal = ({
  candidateFullName,
  onClose,
  onSubmit,
  onClick,
  checked,
}: Props) => {
  return (
    <Modal
      title={i18n.t('ats.candidates.messages.new_message.modal.title')}
      description={i18n.t('ats.candidates.messages.new_message.modal.description', {
        candidate: candidateFullName,
      })}
      illustration="send-email-envelope"
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Box flexDirection="row" gap="s16" flexGrow>
          <Box
            component="label"
            flexDirection="row"
            flexGrow
            gap="s4"
            alignItems="center"
            justifyContent="flexEnd"
          >
            <InputCheckBox onClick={onClick} checked={checked} />
            <Text.Normal>
              {i18n.t('ats.candidates.messages.new_message.modal.remember')}
            </Text.Normal>
          </Box>
          <Button type="negative" submit>
            {i18n.t('ats.candidates.messages.new_message.send_email')}
          </Button>
        </Box>
      }
    />
  )
}
